import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography,
  TextField,
  InputAdornment,
  Alert,
} from '@mui/material';
import {
  Folder as FolderIcon,
  Search as SearchIcon,
  AddToPhotos as AddIcon,
} from '@mui/icons-material';

const AddToFolderModal = ({ 
  open, 
  onClose, 
  onSubmit, 
  folders,
  documentName 
}) => {
  const [selectedFolderID, setSelectedFolderID] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  
  const handleSubmit = () => {
    if (!selectedFolderID) {
      return;
    }
    
    onSubmit(selectedFolderID);
    handleClose();
  };
  
  const handleClose = () => {
    setSelectedFolderID('');
    setSearchTerm('');
    onClose();
  };
  
  // Filter folders based on search
  const filteredFolders = folders?.filter(folder => 
    folder.name.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];
  
  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <AddIcon sx={{ mr: 1 }} />
          Add to Folder
        </Box>
      </DialogTitle>
      
      <DialogContent>
        {documentName && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Adding "{documentName}" to folder
          </Alert>
        )}
        
        <TextField
          fullWidth
          size="small"
          placeholder="Search folders..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />
        
        <Typography variant="subtitle2" gutterBottom>
          Select a folder:
        </Typography>
        
        <List sx={{ maxHeight: 300, overflow: 'auto' }}>
          {filteredFolders.length === 0 ? (
            <ListItem>
              <ListItemText 
                primary="No folders found" 
                secondary="Create a folder first to organize your documents"
              />
            </ListItem>
          ) : (
            filteredFolders.map(folder => (
              <ListItem key={folder.id} disablePadding>
                <ListItemButton
                  onClick={() => setSelectedFolderID(folder.id)}
                  selected={selectedFolderID === folder.id}
                >
                  <ListItemIcon>
                    <Radio
                      checked={selectedFolderID === folder.id}
                      value={folder.id}
                    />
                  </ListItemIcon>
                  <ListItemIcon>
                    <FolderIcon />
                  </ListItemIcon>
                  <ListItemText 
                    primary={folder.name}
                    secondary={folder.description}
                  />
                </ListItemButton>
              </ListItem>
            ))
          )}
        </List>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!selectedFolderID}
        >
          Add to Folder
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddToFolderModal;